export const getCaseStudyPathFromSlug = (slug) => `/work/${slug}`;
